import React, { useState } from "react";
import styled from "styled-components";
import theme from "../utils/theme";
import LicenseModal from "./common/LicenseModal";
import FTLogo1 from "../assets/footer/footer-logo1.svg";
import FTLogo2 from "../assets/footer/footer-logo2.svg";
import FTLogo3 from "../assets/footer/footer-logo3.svg";
import FTLogo4 from "../assets/footer/footer-logo4.svg";

function Footer() {
  const [showLicenseModal, setShowLicenseModal] = useState({
    id: "",
    title: "",
    show: false,
  });

  const lscList = [
    {
      id: "1",
      name: "기업부설연구소",
      heading: "기업부설연구소 인정서",
      img: FTLogo1,
    },
    {
      id: "2",
      name: "대출모집인 등록",
      heading: "대출모집인 등록증",
      img: FTLogo2,
    },
    {
      id: "3",
      name: "벤처기업 혁신유형",
      heading: "벤처기업 확인증",
      img: FTLogo3,
    },
    {
      id: "4",
      name: "한국핀테크 산업협회",
      heading: "한국핀테크 산업협회 회원증",
      img: FTLogo4,
    },
  ];

  return (
    <FooterWrap>
      <LicenseModal
        showLicenseModal={showLicenseModal}
        setShowLicenseModal={setShowLicenseModal}
      />
      <LicenseBar>
        {lscList.map((item, idx) => (
          <LicenseBtn key={item.id}
            onClick={() => setShowLicenseModal({
              id: item.id,
              title: item.heading,
              show: true,
            })}
          >
            <img
              className="change-img"
              src={item.img}
              alt={item.name}
            />
            <span>{item.name}</span>
          </LicenseBtn>
        ))}
      </LicenseBar>
      <CompanyDetail>
        <strong>(주) 이든파이낸셜</strong>
        <div>
          <p className="detail-box detail-top">
            <span>대표 정형화</span>
            <span>사업자 등록 번호 870-88-01482</span>
          </p>
          <p className="detail-box detail-bottom">
            주소 광주광역시 서구 상무대로 747-1 4층(치평동)
            <br />
            <br />
            <span className="copyright">ⓒ Eden Financial Inc. All rights reserved.</span>
          </p>
        </div>
      </CompanyDetail>
    </FooterWrap>
  );
}

const FooterWrap = styled.footer`
  width: 100%;
  background: #2c2c2c;
  color: #bdbdbd;
  padding: 0;
  margin: 0 auto;
  max-width: 430px;
  box-sizing: border-box;
`;

const LicenseBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 12px 8px 12px;
  background: #353535;
`;

const LicenseBtn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #444;
  border-radius: 8px;
  padding: 4px 12px 4px 4px;
  font-size: 13px;
  color: #bdbdbd;
  min-width: 120px;
  height: 36px;
  cursor: pointer;
  background: ${theme.gray70Color};

  img {
    height: 15px;
    margin-right: 8px;
  }
  span {
    font-size: 13px;
    color: #bdbdbd;
    font-weight: 400;
  }
`;

const CompanyDetail = styled.section`
  padding: 24px 16px 32px 16px;
  background: #2c2c2c;
  color: #bdbdbd;
  strong {
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    display: block;
    margin-bottom: 8px;
  }
  .detail-box {
    font-size: 13px;
    color: #bdbdbd;
    margin-bottom: 2px;
    span {
      margin-right: 12px;
    }
  }
  .detail-bottom {
    margin-top: 4px;
    font-size: 13px;
    color: #bdbdbd;
    .copyright {
      display: block;
      margin-top: 8px;
      font-size: 12px;
      color: #bdbdbd;
    }
  }
`;

export default Footer;
